import { render, staticRenderFns } from "./CartNavbarItem.vue?vue&type=template&id=0c7ddd5a&"
import script from "./CartNavbarItem.vue?vue&type=script&lang=js&"
export * from "./CartNavbarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports